//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import collectionSourceAddMenuTemplate from '@legacy-components/content/collection-source-add-menu.html';

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').component('collectionSourceAddMenu', {
    bindings: {
      onAddToCollection: '&',
      secondarySourceId: '<',
      sourceId: '<',
      sourceType: '<',
    },
    template: collectionSourceAddMenuTemplate,
    controller: [
      '$filter',
      '$q',
      '$timeout',
      'CollectionsApiService',
      'CollectionsService',
      'ContentSourceTypes',
      'ErrorNotificationService',
      'ToastNotificationService',
      'TrackedSourcesApiService',
      'TrackingService',
      'rx',
      function(
                $filter,
                $q,
                $timeout,
                CollectionsApiService,
                CollectionsService,
                ContentSourceTypes,
                ErrorNotificationService,
                ToastNotificationService,
                TrackedSourcesApiService,
                TrackingService,
                rx,
            ) {
        const self = this;
        const TRACKING_CATEGORY = TrackingService.CATEGORY_LIBRARY;

        self.shouldShowLoadingSpinner = false;
        self.includedInCollections = {};
        self.collectionsAsyncOutstanding = {};

        const checkIfIncludedInCollection = function(collection) {
          const entityCollectionType = ContentSourceTypes.sourceTypeToCollectionEntityType(self.sourceType);
          if (entityCollectionType === 'Unknown') {
            return false;
          }

          let sources;
          switch (self.sourceType) {
            case ContentSourceTypes.BUSINESS_USER:
              sources = collection.sources.instagramBusinessUsers;
              break;
            case ContentSourceTypes.HASHTAG:
              sources = collection.sources.instagramHashtags;
              break;
            case ContentSourceTypes.USER:
              sources = collection.sources.instagramUsers;
              break;
            default:
              break;
          }

          return _(sources).some((source) => {
            return source.toLowerCase() === self.sourceId.toLowerCase();
          });
        };

        const createCollectionAsync = (newCollectionName) => {
          const collectionName = newCollectionName.trim();
          return CollectionsService.createCollectionWithoutNotification({ name: collectionName })
                        .do(() => TrackingService.recordEvent(TRACKING_CATEGORY, TrackingService.ACTION_COLLECTIONS_CREATE_COLLECTION))
                        .finally(() => {
                          self.shouldShowLoadingSpinner = false;
                        });
        };

        self.addToNewCollection = function(newCollectionName) {
          self.shouldShowLoadingSpinner = true;
          rx.Observable.fromPromise(TrackedSourcesApiService.addTrackedSource({
            sourceType: self.sourceType,
            sourceId: self.sourceId,
            secondarySourceId: self.secondarySourceId,
          }))
            .flatMap(() => createCollectionAsync(newCollectionName))
            .flatMap(collection => rx.Observable.fromPromise(self.addSourceToCollectionAsync(collection)))
            .subscribe(() => {}, (error) => {
              self.shouldShowLoadingSpinner = false;
              if (typeof error === 'string' && error.startsWith('TrackLimit::')) {
                ErrorNotificationService.showNewCollectionTrackLimitErrorDialog(error);
              } else {
                ErrorNotificationService.showDefaultErrorDialog(error);
              }
            });
        };

        self.addSourceToCollectionAsync = function(collection) {
          const sourceTypeStr = self.sourceType.charAt(0).toUpperCase() + self.sourceType.slice(1);
          if (self.includedInCollections[collection.id]) {
            const encodedCollectionName = $filter('htmlEncode')(collection.name);
            const includedToastArgs = {
              title: `Looks like ${self.sourceType} is already added to ${encodedCollectionName}.`,
              message: `<a href="/library/collections/${collection.id}/content">View Collection</a>.`,
              options: {
                allowHtml: true,
                tapToDismiss: false,
              },
            };
            ToastNotificationService.success(includedToastArgs);

            return $q.when();
          }

          self.collectionsAsyncOutstanding[collection.id] = true;

          const promise = CollectionsApiService.addSourceToCollectionAsync(
                        collection.id,
                        self.sourceId,
                        ContentSourceTypes.sourceTypeToCollectionEntityType(self.sourceType),
                        self.secondarySourceId,
                    ).then(() => {
                      const encodedCollectionName = $filter('htmlEncode')(collection.name);
                      const toastArgs = {
                        title: `Awesome! ${sourceTypeStr.replace(/-/g, ' ')} was added to ${encodedCollectionName}.`,
                        message: `<a href="/library/collections/${collection.id}/content">View in collection</a>`,
                        options: {
                          allowHtml: true,
                          tapToDismiss: false,
                        },
                      };

                      self.onAddToCollection();

                      self.includedInCollections[collection.id] = true;
                      CollectionsService.refreshCollections();
                      ToastNotificationService.success(toastArgs);
                    }).catch((error) => {
                      if (typeof error === 'string' && error.startsWith('TrackLimit::')) {
                        ErrorNotificationService.showCollectionTrackLimitErrorDialog(error);
                      } else {
                        ErrorNotificationService.showDefaultErrorDialog(error);
                      }
                    }).finally(() => {
                      self.collectionsAsyncOutstanding[collection.id] = false;
                    });

          return promise;
        };

        self.$onInit = function() {
          CollectionsService.getCollections().subscribe((collectionsState) => {
            self.collections = angular.copy(collectionsState.collections);
            _(self.collections).each((collection) => {
              self.includedInCollections[collection.id] = checkIfIncludedInCollection(collection);
            });
          });
        };
      },
    ],
  });
})();
